module.exports = __webpack_public_path__ + "assets/img/empty-white.8c1061d4.svg";